import 'css-chunk-1JavaScriptSource/components/_PanelDesigner/tageditor/ComponentRulesEditor.module.scss';export default {
  "container": "_container_1wvbs_1",
  "entry": "_entry_1wvbs_6",
  "removeButton": "_removeButton_1wvbs_37",
  "inlineCheckboxContainer": "_inlineCheckboxContainer_1wvbs_40",
  "entryButtons": "_entryButtons_1wvbs_45"
};